import { toast } from 'react-toastify';
import { IHistory } from 'src/interfaces';
import pdfMake from 'pdfmake/build/pdfmake';
import vfsFonts from 'pdfmake/build/vfs_fonts';
import { detailsReportPagePdfMake } from '../utils/generalUtils';
import { SUBMISSION_FAILED } from '../constants/generals';
import {
    asyncForEach, base64ToFile, deleteImageFromS3,
    getCurrentUserUUID, uploadImageToS3
} from '../utils/generalUtils';
import { getDev, postDev } from '../utils/HTTPDev';
import { ChecklistModel } from '../model/ChecklistModel';
declare var require: any;
const uuidv1 = require('uuid/v1');
import { format } from 'date-fns';

export async function getQuestions(formType: string) {
    try {
        const response = await getDev(`/getquestions/${formType}`);
        return response.data.data;
    } catch (error) {
        throw error;
    }
}

export async function uploadImages(base64Array: string[], dirName: string) {
    return '';
    /* const S3_URL = 'https://enviroconnect.s3.us-west-2.amazonaws.com';
    const images = [];
    const start = async () => {
        await asyncForEach(base64Array, async (base64) => {
            const fileName = `${uuidv1()}.png`;
            const { file, filename } = await base64ToFile(base64, fileName);
            const s3object = await uploadImageToS3(file, filename, dirName);
            if (s3object) {
                images.push(`${S3_URL}/${dirName}/${filename}`);
            }
        });
        return images;
    };
    return start(); */
}

export async function deleteImages(fileName: string[], dirName: string) {
    const images = [];
    const start = async () => {
        await asyncForEach(fileName, async (file) => {
            const s3object = await deleteImageFromS3(file, dirName);
            images.push(s3object.location);
        });
        return images;
    };
    return start();
}

export function imageExists(image_url){ 
    var http = new XMLHttpRequest(); 
    http.open('HEAD', image_url, false);
    http.send(); 
    return http.status != 404; 
}

export async function submitTechnicalFeedback(data, history: IHistory) {
    try {
        const response = await postDev('/feedback', {
            feedback: data.comments,
            userId: getCurrentUserUUID()
        });

        toast.success(response.data.message, {
            position: toast.POSITION.TOP_CENTER,
            className: 'success-toast'
        });
        setTimeout(() => {
            history.push('/home');
        }, 2000);
    } catch (error) {
        toast.error(SUBMISSION_FAILED, {
            position: toast.POSITION.TOP_CENTER,
            className: 'failed-toast'
        });
        throw error;
    }
}

export function prepareTable(instance: ChecklistModel, questions: { Question: string; }[], title: string, colWidth: number, formType: string) { 
    const formName = instance.props.type;
    let values = [{ text: `${formType}/Question`, style: 'tableHeader' }];
    instance.props.answers.forEach((val, index) => {
        let title: string | number = index + 1;
        if(formName=='MonthlySPCC' && instance.props.answers.length==13) {
            title = index==7 ? 'Month/Question' : index > 7 ? index : title;
        }
        return values.push({ text: `${title}`, style: 'tableHeader' });
    });
    let answers = [values];
    const colLength = instance.props.answers.length; 
    const rowLength = instance.props.answers[0].data.length;
    //const rowLength = questions.length;
    for (let index = 0; index < rowLength; index++) {
        const count = [];
        let ques = questions[index].Question;
        if(formName=='MonthlySW' && ques=='Time') {
            count.push('Actual Date');
        } else if(formName=='MonthlySW' && ques=='Actual Date') {
            count.push('Signature URL');
        } else if(formName=='ShopInspection' && ques=='Acknowledged By') {
            count.push('Signature URL');
        } else { 
            count.push(questions[index].Question);
        }
       /*  if (questions[index].Question === 'Time') {
            count.push('Actual Date');
        } else if (questions[index].Question === 'Actual Date') {
            count.push('Signature URL');
            //count.push('Actual Date Actual');
        } else {
            count.push(questions[index].Question);
        } */

        for (let i = 0; i < colLength; i++) {
            const { answers } = instance.props;
            let answer = answers[i].data.length && answers[i].data[index].answer.answer || '';
            let ansconstent = answer ? ( answers[i].data[index].answer['quesNum']==='61' ? format(answer, 'MM/DD/YYYY') : (  formName=='DailyForm' && (answer!='Yes' && answer!='No' ) ? '' : ( formName=='PlantPreventive' ? (answer==='Yes' || answer==='Ok'?'OK':(answer==='No' || answer.indexOf('Needs work-') > -1 ?'No':'') ) :  answer ) ) ) : '';
            count.push(ansconstent);
        }
        answers.push(count);
    }
    const { vfs } = vfsFonts.pdfMake;
    pdfMake.vfs = vfs;
    const widths = [60];
    const heights = [30];
    answers[0].forEach((ansData) => {
        widths.push(colWidth);
        heights.push(30);
    });
    const docDefinition = {
        pageOrientation: 'landscape',
        content: [
            { text: title, style: 'header' },
            {
                style: 'checklistTable',
                table: {
                    widths,
                    body: answers
                }
            }
        ],
        'styles': {
            'header': {
                'fontSize': 18,
                'bold': true,
                'margin': [
                    0,
                    0,
                    0,
                    10
                ]
            },
            'checklistTable': {
                'fontSize': 8,
                'textAlign': 'center',
                'margin': [
                    0,
                    0,
                    0,
                    0
                ]
            },
            'tableHeader': {
                'bold': true,
                'fontSize': 10,
                'color': 'black'
            }
        }
    };
    pdfMake.createPdf(docDefinition).download(`${title}.pdf`);
}

export function pdfMaker(instance: any, region: string, plantId: string, date: string, userName: string) {
    const firstSectionData = instance.questions.slice(0, 38);
    const secondSectionData = instance.questions.slice(38);
    let values = detailsReportPagePdfMake(firstSectionData);
    let secondSectionvalues = detailsReportPagePdfMake(secondSectionData);
    const { vfs } = vfsFonts.pdfMake;
    pdfMake.vfs = vfs;
    const docDefinition = {
        pageOrientation: 'portrait',
        content: [
            {
                text: 'Plant Preventive Form Details'
                , fontSize: 8,
                bold: true,
                margin: [0, 5, 0, 5]
            },
            {
                text: `Region: ${region} \t Plant Id: ${plantId} \t Date: ${date} \t Inspected By: ${userName}`
                , fontSize: 8,
                bold: true,
                margin: [0, 5, 0, 5]
            },
            {

                columns: [values.values, secondSectionvalues.values],
            },
            { text: `Notes:`, fontSize: 8, bold: true, margin: [0, 5, 0, 5] },
            {
                table: {
                    widths: ['100%'],
                    headerRows: 1,
                    body: [
                        [
                            { text: ` ${values.notes} ${secondSectionvalues.notes}`, fontSize: 8 },
                        ]
                    ],
                },
            }
        ]
    };
    pdfMake.createPdf(docDefinition).download(`PlantPreventive.pdf`);

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/formService.ts